import { createFileRoute } from "@tanstack/react-router";
import { AdminPageHeader } from "@/components/admin/admin-shell";
import { CrudManager } from "@/components/admin/crud-manager";

export const Route = createFileRoute("/_authenticated/admin/promokodlar")({
  component: Page,
});

function Page() {
  return (
    <div>
      <AdminPageHeader
        title="Promo kodlar və bonuslar"
        description="Endirim və balans bonusu kodlarını idarə et"
      />
      <CrudManager
        table="promo_codes"
        addLabel="Yeni promo kod"
        emptyText="Promo kod yoxdur."
        fields={[
          { name: "code", label: "Kod", placeholder: "ALBAZAR10" },
          {
            name: "kind",
            label: "Növ",
            type: "select",
            options: [
              { value: "bonus", label: "Balans bonusu (AZN)" },
              { value: "discount", label: "Endirim (%)" },
            ],
          },
          { name: "amount", label: "Məbləğ", type: "number" },
          { name: "max_uses", label: "İstifadə limiti", type: "number" },
          { name: "active", label: "Aktiv", type: "boolean" },
        ]}
        columns={[
          { name: "code", label: "Kod" },
          {
            name: "kind",
            label: "Növ",
            render: (r) => (r["kind"] === "discount" ? "Endirim" : "Bonus"),
          },
          { name: "amount", label: "Məbləğ" },
          {
            name: "used_count",
            label: "İstifadə",
            render: (r) => `${r["used_count"] ?? 0} / ${r["max_uses"] ?? 0}`,
          },
          { name: "active", label: "Vəziyyət", render: (r) => (r["active"] ? "Aktiv" : "Deaktiv") },
        ]}
      />
    </div>
  );
}
